import * as QRCodePrestoLogo from './qrcode-presto-logo.png';
import * as TickIcon from './icon-tick.png';
import { BunnyHeadIcon } from './icons';

import MalaysiaFlag from './flags/my.svg';
import SingaporeFlag from './flags/sg.svg';
import IndonesiaFlag from './flags/id.svg';
import PhilippinesFlag from './flags/ph.svg';
import ThailandFlag from './flags/th.svg';
import ChinaFlag from './flags/cn.svg';
import JapanFlag from './flags/jp.svg';
import SouthKoreaFlag from './flags/kr.svg';

import LeftArrow from './left-arrow.png';

import MobileIcon from './icon-mobile.png';
import MobileSelectedIcon from './icon-mobile-selected.png';
import PasswordIcon from './icon-password.png';
import PasswordSelectedIcon from './icon-password-selected.png';
import PinIcon from './icon-pin.png';
import PinSelectedIcon from './icon-pin-selected.png';

import PoweredByPrestoLogo from './powered-by-presto.png';

import PreloaderPresto from './preloader-presto.json'

const Flags = {
    MY: MalaysiaFlag,
    SG: SingaporeFlag,
    ID: IndonesiaFlag,
    PH: PhilippinesFlag,
    TH: ThailandFlag,
    CN: ChinaFlag,
    JP: JapanFlag,
    KR: SouthKoreaFlag,
};

export {
    QRCodePrestoLogo,
    BunnyHeadIcon,
    TickIcon,
    MobileIcon,
    MobileSelectedIcon,
    PasswordIcon,
    PasswordSelectedIcon,
    PinIcon,
    PinSelectedIcon,
    PoweredByPrestoLogo,
    PreloaderPresto,

    Flags,
    LeftArrow,
}